export var oversizedUploadText = 'Lists are limited to a maximum of 1,500 locations. Please cancel this edit and ensure your final list will contain no more than 1,500 locations.';
export var loaderMessages = {
    defaultMessage: 'This may take a few minutes. Please do not navigate away from this page.',
    uploadHeader: 'Your locations are being uploaded.',
};
export var nav = {
    newsAndEvents: 'News & Events',
    about: 'About',
    users: 'Users',
    blog: 'Blog',
    myGfwPro: 'My GFW Pro',
    username: 'Username',
    usernameOrEmail: 'Username or email',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    rememberMe: 'Remember me',
    login: 'Log in',
    requestAccount: 'Request an account',
    loginError: 'There was a login error!',
    more: 'More',
    menu: 'Menu',
    moreMenu: {
        apps: 'Apps',
        allApps: 'All apps',
        appsDescription: 'All our solutions in one place!',
        sharingAndSecurityDescription: 'Information about sharing and security.',
        about: 'About',
        blog: 'Blog',
        other: 'Other applications',
        exploreAllApps: 'Explore all apps',
        title: 'More in GFW Pro',
        howTo: 'How to Portal',
        security: 'Security',
        securityLink: 'https://d1ps9kreypzu9a.cloudfront.net/Training%20Guides/GFW%20Pro%20Landing%20Page/World_Resources_Institute_GFW_Pro_Security.pdf',
        sharing: 'Sharing',
        sharingLink: 'http://d1ps9kreypzu9a.cloudfront.net/Training%20Guides/GFW%20Pro%20Landing%20Page/GFW%20Pro%20Information%20Sharing%20One%20Pager_April2019.pdf',
    },
};
export var verifyCodePage = {
    pageTitle: 'GFW Pro Verification code',
    pagePrompt: 'Enter the code that was emailed to you.',
    inputLabel: 'Code',
    buttonLabel: 'Verify',
    backButtonLabel: 'Back to website',
    newCodeString1: 'Send new',
    newCodeString2: 'code.',
};
export var diagnosticsStrings = {
    listOrLocationNotFound: 'List or location not found',
};
